import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-xl border border-[#E5E5E5] bg-white px-3 py-2 text-sm text-[#1C1C1C] shadow-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#1C1C1C] placeholder:text-[#A3A3A3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2C4C3B]/30 focus-visible:border-[#2C4C3B] disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[#F3F4F1]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
